/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {signal} from '@preact/signals-react';
import {createMutator} from '../store/SignalUtils';

/**
 * Defines the state for determining if cross environment notification is
 * to be displayed to the user
 */
export const showNotification = signal<boolean>(false);
export const setShowNotification = (
  createMutator<boolean>(showNotification) as (value: boolean) => boolean
);

/**
 * Defines the state for specifying if the user is permitted to access cross
 * environment services. By default, this value is set to `true`, and is to
 * be set to `false` when the user is not permitted to access cross environment
 * services based on application specific restrictions, such as the user's role
 * and / or permissions.
 */
export const isPermitted = signal<boolean>(true);
export const setIsPermitted = (
  createMutator<boolean>(isPermitted) as (value: boolean) => boolean
);
